import { AppBar, Toolbar } from "@material-ui/core";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import NotificationsIcon from "@material-ui/icons/Notifications";
import React from "react";
import { useDispatch } from "react-redux";
import Logo from "../../../assets/JustMeasureLogo.png";
import { useAuth0 } from "../../../auth/react-auth0-spa";
import { toggleNotificationDrawer } from "../../../state/ducks/notification/operations";


const AppHeaderBar: React.FC = () => {
  const { logout, isAuthenticated } = useAuth0();
  const logOut = () => logout({ returnTo: window.location.origin });
  const dispatch = useDispatch();
  const toggleNotifcationDrawer = () => toggleNotificationDrawer()(dispatch);
  return (
    <AppBar className="mobile appBar" position="fixed">
      <Toolbar>
        <img width={200} src={Logo} alt="JustMeasureLogo" className="logo" />
        {isAuthenticated && (
          <NotificationsIcon
            onClick={toggleNotifcationDrawer}
            width={40}
            className={"notificationIcon"}
            height={40}
          />
        )}
        {isAuthenticated && (
          <ExitToAppIcon
            onClick={logOut}
            width={40}
            className={"logOutIcon"}
            height={40}
          />
        )}
      </Toolbar>
    </AppBar>
  );
};
export default AppHeaderBar;
